export default __webpack_public_path__ + "static/media/icon-hamburger.dc022bac.svg";